import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import { TextStyle } from 'data/FontStyle';
import useWindowsDimension from 'functions/useWindowsDimension';
import { ITicketBillingViewModel } from 'Interfaces/ITicketConfig';
import { EditTicketBillingForm } from 'pages/Billing/Components/EditTicketBillingForm';
import React, { useState } from 'react';

type EditCompanyProductDrawerProps = {
  buttonIcon: React.ReactNode | null; // or 'any' if you prefer
  buttonContext: string; // or 'any', but string is typically used
  ticket: ITicketBillingViewModel; // Optional prop for company product
  onSave: (editedTicket: ITicketBillingViewModel) => void;
  totalBillingValue?: number;
};

export const EditTicketBillingDrawer = ({
  buttonIcon,
  buttonContext,
  ticket,
  onSave,
  totalBillingValue,
}: EditCompanyProductDrawerProps) => {
  const { width } = useWindowsDimension();
  const [open, setOpen] = useState(false);
  let buttonWidth = buttonIcon === null ? '100%' : 32;
  let buttonHeight = buttonIcon === null ? 64 : 32;

  console.log('TK EDIT', ticket);
  // HANDLES
  const handleSave = (editedTicket: ITicketBillingViewModel) => {
    console.log('Saving edited ticket:', editedTicket);
    console.log('Saving edited ticket:', editedTicket);
    onSave?.(editedTicket); // Call the onSave callback
    setOpen(false); // Close the drawer after saving
  };

  return (
    <>
      {buttonIcon === null ? (
        <Button
          variant='contained'
          sx={{
            borderRadius: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            width: buttonWidth || '100%',
            height: buttonHeight || '100%',
          }}
          onClick={() => setOpen(!open)}
        >
          <Typography
            sx={{
              textTransform: 'uppercase',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 'bold',
              fontSize: 14,
              letterSpacing: 2,
              color: 'primary.text',
            }}
          >
            {buttonContext}
          </Typography>
        </Button>
      ) : (
        <Box
          sx={[
            TextStyle.buttonBox,
            {
              width: buttonWidth || 32,
              height: buttonHeight || 32,
            },
          ]}
        >
          <IconButton
            sx={{
              p: 0,
              m: 0,
              width: buttonWidth || 18,
              height: buttonHeight || 18,
            }}
            onClick={() => setOpen(!open)}
          >
            {buttonIcon}
          </IconButton>
        </Box>
      )}
      <Drawer anchor={'left'} open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: width / 2, backgroundColor: 'primary.main' }}>
          <EditTicketBillingForm
            ticket={ticket}
            onSave={handleSave}
            onCancel={() => setOpen(false)}
            totalBillingValue={totalBillingValue}
          />
        </Box>
      </Drawer>
    </>
  );
};
